module.exports = "<div class=\"hero-foot\">\r\n    <div class=\"container\">\r\n    <div class=\"tabs is-centered\">\r\n        <ul class=\"foot\">\r\n        <li><a href=\"http://bulma.io\">Made with Bulma</a></li>\r\n        <li><a>Copyright 2017-2018 Tony Santi</a></li>\r\n        </ul>\r\n    </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/dev/github/ng4wedding/wedding/src/app/chrome/footer/footer.component.html
// module id = ../../../../../src/app/chrome/footer/footer.component.html
// module chunks = main